import React, { useMemo, useState } from "react";
import { observer } from "mobx-react-lite";

import FormField from "../../../components/form-field/FormField";
import { api } from "../../../services/api/ApiService";
import { Dropdown } from "../../../components/dropdown/Dropdown";
import { ProjectReportTemplateServiceModel } from "../../../services/project/ProjectReportTemplateService";
import { ReportTemplate } from "../../../services/organization/ReportTemplate";

interface EditReportTemplateProps {
  value?: ReportTemplate;
  setFieldValue?: Function;
}

export const emptyReportTemplate = { id: "", name: "" };

export const EditReportTemplate = observer(({ value, setFieldValue }: EditReportTemplateProps) => {
  const [projectReportTemplateService] = useState(() =>
    ProjectReportTemplateServiceModel.create({}, { api })
  );

  const options = useMemo(() => {
    return projectReportTemplateService.loadingTemplates
      ? [{ id: value!.id, name: value!.name }]
      : projectReportTemplateService.reportTemplates.map((x) => {
          return { id: x.id, name: x.name };
        });
  }, [
    projectReportTemplateService.loadingTemplates,
    projectReportTemplateService.reportTemplates,
    value,
  ]);

  return (
    <FormField
      id="project-report-template"
      labelKey="general.project.report-template"
      fieldName="reportTemplate"
      fieldValue={value}
      errorName="reportTemplate"
      children={() => (
        <div className="form-element-container">
          <Dropdown
            selectedOption={value ?? null}
            options={options}
            fieldName="reportTemplate"
            setFieldValue={setFieldValue}
            canClearSelection
            placeholderKey="general.project.report-template.select"
          />
        </div>
      )}
    />
  );
});
